import React, { useEffect } from "react";
import Container from 'react-bootstrap/Container';

function createImageNode(i,image) {    
    var divCol = document.createElement('div');
    divCol.className = "col";

    var img = document.createElement('img');
    img.src = `data:image/jpeg;base64,${image.imageEncoded}`;
    //img.width = "300";
    if (i != 0) {
        img.style.margin = "15px";
    }

    divCol.appendChild(img); //ajouter pour les col
    var a = document.createElement('a');
    if(image.linkImage!=null){
        a.target="_blank"
        a.href = image.linkImage;
        //divCol.appendChild(img);
        a.appendChild(img);
        return a;
    }
    //return divCol;
    return img;
}

function createImage(){
    return (      
        <div>
           <p>Test</p>
        </div>    
     );
}

export function Banniere() {
    function display(data) {
        data.sort((a, b) => a.position - b.position);
        for (let i = 0; i < data.length; i++) {
            document.getElementById("images").appendChild(createImageNode(i, data[i]));
        }
    }

    useEffect(() => {
        fetch('/lineup/api/image/allImagesForBanniere')
            .then(response => {
                response.json().then(data => {
                    display(data)
                }).catch(err => {
                    console.log("Erreur lors de la recupération des données");
                    console.log(err)
                })
            }).catch(err => {
                console.log("Impossible d'accéder à l'api");
                console.log(err)
            });
    }, []);

    return (
        <Container>
            <div id="images">
            </div>
            {/* <img src={banniereImg} alt="Banniere" className="d-inline-block align-top" />     */}
        </Container >
    );
}
export default Banniere;